import _defineProperty from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

var _We, _symbols3, _symbols4;

/*! Provides core utilities for the working with both versions of the ESRI JSAPI.
 *
 * @ai360/core v35.6.1 (https://bitbucket.org/agvanceskyteam/ai360.client.core.git)
 * SSI DO NOT COPY!!!
 */
export { A as AutoDirection, f as FormattingHelpers, b as GeometryMath, G as GeometryUtils, M as METERS_PER_FOOT, S as SQ_METERS_PER_ACRE, T as TempDisableTimer, c as calculateMinMaxRangeForGridCells, a as createGridCells, k as keyboardNavInfo, p as panInfo, z as zoomInfo } from "./common/geometry/utils.js";
export { G as GeometryCreator } from "./common/geometry/creator.js";
export { B as BaseLayer, b as BigDataLayer, C as CanvasLayer, c as CanvasLayerSimpleUVR, a as CanvasLayerView, D as DggLayer, k as FIELDS, d as FieldBoundaryApiAspect, F as FieldBoundaryImportLayer, e as FieldsLayer, I as ImageLayer, p as ImageryTileLayer, f as ImportDataConvexHullLayer, l as LABEL_ONLY, L as LegacyCanvasLayer, M as MultiFieldImageryLayer, g as MultiLayer, N as NonFieldFeaturesLayer, i as PolygonFeatureLayer, P as PolygonLayer, j as SampleSitesLayer, m as ScoutingObservationsLayer, h as StoredItem, S as StoredLayer, o as SurfaceLayer, n as SurfaceType, T as TileLayer } from "./common/layers/surface-layer.js";
export { J as JSONUtils, R as RendererUtils, S as SymbolUtils, o as orangeCrosshatch } from "./common/symbols.js";
export { C as CanvasLayerUtils, G as GraphicUtils, L as LayerUtils, M as MapConfig, m as MapUtils, c as createUniqueValueRenderer } from "./common/utils/map.js";
import { i as Q } from "./common/index.js";
export { A as ApiSpatialReference, a as AppHelpers, s as SortingHelpers, T as ToolConfig } from "./common/index.js";
export { B as BaseToolbar } from "./common/base-toolbar.js";
export { A as AREA_ID, Z as ZoneToolsBase } from "./common/zone-tools-base.js";
export { D as DrawTools } from "./common/toolbars/draw-tools.js";
export { E as ExtentTools } from "./common/extent-tools.js";
export { M as MeasureTools } from "./common/toolbars/measure-tools.js";
export { n as NonFieldFeatureTools } from "./common/toolbars/non-field-feature-tools.js";
export { G as GridPointPlacementMethod, S as SamplingTools, i as isSampleLabelComposite, u as updateSampleLabelSequence } from "./common/toolbars/sampling-tools.js";
export { S as ScoutingZoneTools } from "./common/toolbars/scouting-zone-tools.js";
export { r as ReferenceAPI, S as SearchTools } from "./common/toolbars/search-tools.js";
export { D as DetailType, Z as ZoneTools } from "./common/toolbars/zone-tools.js";
export { H as HistoryManager } from "./common/history-manager.js";
export { A as AutoPan, L as ListenerManager, P as PanDirections } from "./common/utils/auto-pan.js";
export { D as DeltaHistoryManager, H as HistoryMoment } from "./common/delta-history-manager.js";
export { L as LabelManager } from "./common/label-manager.js";
export { Z as ZoneClassificationProperties, a as ZoneClassificationUtils } from "./common/zone-classification.js";
export { b as BasemapUtils, c as ConversionUtils } from "./common/utils/basemaps.js";
export { C as ClassBreak, Z as ZoneUtils, a as addNullZoneClassBreak, c as classBreaksWithRecalculatedAcreage, d as clipZoneOverlaps, b as clipZones, e as clipZonesToField, g as getResidualZone, m as mergeResidualZoneOrAddClassBreak, f as mergeSlivers, p as processResidualAreaZoneForSurface } from "./common/utils/zone.js";
export { A as ApplicationModule, e as Confirm, C as Cursor, c as GeometryCreatorType, G as GeometryType, I as InterpolationType, L as LayerIds, a as LayerType, S as SamplePointGuidProperty, f as SamplingAction, d as ToastType, T as Tool, b as Toolset } from "./common/enums.js";
export { FieldUtils, STATUS } from "./helpers/field/index.js";
import { R as ee, a as te, b as oe, Q as re, m as ie, c as ae } from "./common/api/rec.js";
export { a2 as APICommandFailed, $ as APIError, a0 as APIErrorInvalidSchema, a1 as APIErrorWithCode, f as AccountAPI, g as AddressAPI, h as AdminScriptsAPI, X as AgEventAPI, S as AgvanceAPI, i as Ai360API, j as Ai360UserAPI, T as AnalysisLayerAPI, k as AnalyticsAPI, _ as ApiErrorType, d as Credentials, l as CropAPI, o as CustomerAPI, Z as DetailedApiStatus, q as EquipmentProfileAPI, U as EventAPI, r as FieldAPI, s as FileImportAPI, t as GrowthStageOrderAPI, v as HierarchyAPI, w as ImportAttributeAPI, x as ImportDataFilterAPI, y as LayerAPI, a6 as LocalStorageHelpers, z as LocationMigrationAPI, A as NutrientTargetValueAPI, B as OwnerAPI, C as PersonAPI, D as PreferenceAPI, E as ProductAssignmentAPI, Y as RecAPI, V as RecAreaAPI, F as ReportAPI, R as Request, G as SearchAPI, H as SetupAPI, a7 as SpatialHelpers, I as SurfaceDefaultsAPI, J as SystemAPI, K as TemplateAPI, L as UserAPI, M as UserRoleAPI, N as VendorAPI, O as WeatherAPI, P as ZapperAPI, W as ZoneAPI, b as aggregateUrlGenerator, a3 as ajv, a as apiUrl, a5 as getAuthorizationHeader, n as newApiUrl, p as pdfUrl, u as urlBase, e as urlJoin, a4 as validateResults } from "./common/api/rec.js";
export { n as NonFieldFeatureAPI } from "./common/non-field-feature.js";
import { v4 as le } from "uuid";
import se from "lodash";
import "@arcgis/core/geometry/SpatialReference";
import "@arcgis/core/Graphic";
import "@arcgis/core/tasks/Locator";
import "@arcgis/core/geometry/support/webMercatorUtils";
import "@arcgis/core/geometry/support/jsonUtils";
import "@arcgis/core/geometry/projection";
import "@terraformer/arcgis";
import "@arcgis/core/geometry/Polygon";
import { device as ne } from "aws-iot-device-sdk";
import "polylabel";
import "@arcgis/core/geometry/geometryEngine";
import "@arcgis/core/geometry/Multipoint";
import "@arcgis/core/geometry/Point";
import "@arcgis/core/geometry/Polyline";
import "@arcgis/core/geometry/Extent";
import "@terraformer/wkt";
import "@arcgis/core/geometry/coordinateFormatter";
import "@arcgis/core/tasks/GeometryService";
import "@arcgis/core/rest/geometryService";
import "moment";
import "@arcgis/core/geometry";
import "@arcgis/core/geometry/support/geodesicUtils";
import "./common/tslib.es6.js";
import "@arcgis/core/geometry/Circle";
import "@arcgis/core/layers/GraphicsLayer";
import "@arcgis/core/renderers/UniqueValueRenderer";
import "@arcgis/core/symbols/SimpleFillSymbol";
import "@arcgis/core/layers/WebTileLayer";
import "@arcgis/core/layers/support/TileInfo";
import "immutable";
import "@arcgis/core/PopupTemplate";
import "fast-deep-equal";
import "@arcgis/core/layers/FeatureLayer";
import "@arcgis/core/layers/Layer";
import "@arcgis/core/views/2d/layers/BaseLayerView2D";
import "@arcgis/core/core/accessorSupport/decorators";
import "@arcgis/core/core/watchUtils";
import "@arcgis/core/core/workers";
import "@arcgis/core/config";
import "@arcgis/core/symbols/support/jsonUtils";
import "@arcgis/core/renderers/support/jsonUtils";
import "@arcgis/core/geometry/Geometry";
import "@arcgis/core/layers/TileLayer";
import "@arcgis/core/layers/VectorTileLayer";
import "@arcgis/core/layers/MapImageLayer";
import "@arcgis/core/layers/support/LabelClass";
import "natsort";
import "@arcgis/core/Basemap";
import "@arcgis/core/widgets/Sketch/SketchViewModel";
import "@arcgis/core/widgets/Search";
import "@arcgis/core/widgets/Search/LocatorSearchSource";
import "simple-statistics";
import "@reduxjs/toolkit/query/react";
import "react-xml-parser";
import "ajv";
import "ajv/lib/refs/json-schema-draft-04.json";
import "amazon-cognito-identity-js";
import "decimal.js";

var capitaliseFirstLetter = function capitaliseFirstLetter(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
};

function downloadBlobFileChrome(e, t, o) {
  if (null != e) {
    var r = document.createElement("a");
    document.body.appendChild(r), r.style = "display: none";
    var i = r.href = window.URL.createObjectURL(new Blob([e], {
      type: "octet/stream"
    }));
    r.download = "".concat(t, ".").concat(o), r.click(), window.URL.revokeObjectURL(i);
  }
}

function downloadFile(e, t, o) {
  e && (t.toLowerCase().endsWith("." + o.toLowerCase()) && (t = t.substring(0, t.lastIndexOf("."))), "InstallTrigger" in window || "chrome" in window && "webstore" in window.chrome ? downloadBlobFileChrome(e, t, o) : (Q() || !Q() && window.StyleMedia) && window.navigator.msSaveOrOpenBlob(e, "".concat(t, ".").concat(o)));
}

var de = Object.freeze({
  __proto__: null,
  capitaliseFirstLetter: capitaliseFirstLetter,
  createSort: function createSort(e) {
    if (null == e || e.length < 1) return null;

    var createSrt = function createSrt(e, t, o) {
      var r = {},
          i = {};
      return null != e && null != e && null != t && null != t && (e.length > 0 && (r.FieldName = capitaliseFirstLetter(e)), i.Direction = t.toUpperCase(), i.Order = o, r.Sort = i), r;
    },
        t = [];

    for (var o = 0; o < e.length; o++) {
      var r = e[o];
      t.push(createSrt(r.field, r.dir, o));
    }

    return t;
  },
  downloadBlobFileChrome: downloadBlobFileChrome,
  downloadFile: downloadFile,
  downloadBlob: function downloadBlob(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "default";
    var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "csv";
    var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
    var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 512;

    if (e) {
      var a = atob(e),
          l = [];

      for (var _e2 = 0; _e2 < a.length; _e2 += i) {
        var _t = a.slice(_e2, _e2 + i);

        var _o = new Array(_t.length);

        for (var _e3 = 0; _e3 < _t.length; _e3++) {
          _o[_e3] = _t.charCodeAt(_e3);
        }

        var _r = new Uint8Array(_o);

        l.push(_r);
      }

      downloadFile(new Blob(l, {
        type: r
      }), t, o);
    }
  }
}),
    ce = Object.freeze({
  __proto__: null,
  checkSecurityAnswer: function checkSecurityAnswer(e, t) {
    return ee.post(te("Authentication/CheckSecurityAnswer"), {
      email: e,
      answer: t
    });
  },
  firstTimeUserResetPassword: function firstTimeUserResetPassword(e) {
    return ee.post(te("Authentication/FirstTimeUserResetPassword"), {
      email: e
    });
  },
  getEnrollmentForm: function getEnrollmentForm(e) {
    return ee.post(te("Authentication/GetEnrollmentForm"), {
      customerGuid: e
    });
  },
  getLoginUser: function getLoginUser() {
    return ee.post(te("Authentication/GetLoginUser"));
  },
  getSecurityQuestion: function getSecurityQuestion(e) {
    return ee.post(te("Authentication/GetSecurityQuestion"), {
      email: e
    });
  },
  getPossibleSecurityQuestions: function getPossibleSecurityQuestions() {
    return ee.post(te("Authentication/GetPossibleSecurityQuestions"));
  },
  getLoginBackgroundUrl: function getLoginBackgroundUrl() {
    return ee.post(te("Authentication/GetLoginBackgroundUrl"));
  },
  keyLogin: function keyLogin(e) {
    return ee.post(te("Authentication/KeyLogin"), {
      key: e
    });
  },
  getIdpConfig: function getIdpConfig() {
    return ee.post(te("Authentication/GetIdpConfig"));
  },
  getIotConfig: function getIotConfig() {
    return ee.post(te("Authentication/GetIotConfig"));
  },
  getIotIdentityId: function getIotIdentityId(e, t) {
    return ee.post(te("Authentication/GetIotIdentityId"), {
      IdentityPoolId: e,
      Logins: t
    });
  },
  SetLastUsedLogin: function SetLastUsedLogin(e, t, o, r) {
    return ee.post(te("Authentication/SetLastUsedLogin"), {
      UserGuid: e,
      Model: {
        lastUsedCompanyGuid: t,
        lastUsedCustomerGuid: r,
        lastUsedLocationGuid: o
      }
    });
  },
  logout: function logout() {
    return ee.post(te("Authentication/Logout"));
  },
  resetPassword: function resetPassword(e, t) {
    return ee.post(te("Authentication/ResetPassword"), {
      email: e,
      password: t
    });
  },
  setSecurityQuestion: function setSecurityQuestion(e, t, o) {
    return ee.post(te("Authentication/SetSecurityQuestion"), {
      email: e,
      securityQuestion: t,
      securityAnswer: o
    });
  },
  updateLastEulaAcceptance: function updateLastEulaAcceptance(e) {
    return ee.post(te("Authentication/UpdateLastEulaAcceptance"), {
      loginGuid: e
    });
  },
  sendVerificationCode: function sendVerificationCode(e, t) {
    return ee.post(te("Authentication/SendVerificationCode"), {
      customerGuid: e,
      phoneNumber: t
    });
  },
  confirmVerificationCode: function confirmVerificationCode(e, t) {
    return ee.post(te("Authentication/ConfirmVerificationCode"), {
      customerGuid: e,
      verificationCode: t
    });
  },
  setCustomerEnrolled: function setCustomerEnrolled(e, t) {
    return ee.post(te("Authentication/SetCustomerEnrolled"), {
      customerGuid: e,
      dataPooling: t
    });
  },
  getCustomerEnrollmentStatus: function getCustomerEnrollmentStatus(e) {
    return ee.post(te("Authentication/GetEnrollmentStatus"), {
      customerGuid: e
    });
  }
}),
    ue = Object.freeze({
  __proto__: null,
  getAvailableSoilTypeDataByFieldGuids: function getAvailableSoilTypeDataByFieldGuids(e, t, o) {
    return ee.post(te("ChromelessReports/GetAvailableSoilTypeDataByFieldGuids"), {
      Model: {
        reportGuid: e,
        fieldGuids: t,
        soilTypeAttribute: o
      }
    }, void 0, void 0, !0);
  },
  getLoadsheetInfo: function getLoadsheetInfo(e, t, o, r, i, a, l) {
    return ee.post(te("ChromelessReports/GetLoadsheetInfo"), {
      Model: {
        addProductDetailsYn: i,
        companyGuid: e,
        recBatchGuid: t,
        userGuid: o,
        jobId: r,
        useCustomImagery: a,
        reportGuid: l
      }
    }, void 0, void 0, !0);
  },
  getLayerReportInfo: function getLayerReportInfo(e, t, o, r, i, a, l) {
    return ee.post(te("ChromelessReports/GetLayerReportInfo"), {
      Model: {
        companyGuid: o,
        fieldGuid: e,
        surfaceRendererGuid: t,
        imageryLayerGuid: r,
        isSampleSites: i,
        agEventGeneralGuid: a,
        reportGuid: l
      }
    }, void 0, void 0, !0);
  },
  getLayerReportInfoLite: function getLayerReportInfoLite(e, t) {
    return ee.post(te("ChromelessReports/GetLayerReportInfo"), {
      Model: {
        excludeLogos: !0,
        fieldGuid: e,
        surfaceRendererGuid: t
      }
    }, void 0, void 0, !0);
  },
  getPlantingManualLoadsheetInfo: function getPlantingManualLoadsheetInfo(e, t, o, r) {
    return ee.post(te("ChromelessReports/GetPlantingManualLoadsheetInfo"), {
      Model: {
        companyGuid: e,
        recGeneralGuidList: t.split(","),
        useCustomImagery: o,
        reportGuid: r
      }
    }, void 0, void 0, !0);
  },
  addReportInfo: function addReportInfo(e) {
    return ee.post(te("ChromelessReports/AddReportInfo"), {
      Model: e
    }, void 0, void 0, !0);
  },
  getReportImageInfo: function getReportImageInfo(e) {
    return ee.post(te("ChromelessReports/GetReportImageInfo"), {
      Model: {
        reportImageGuid: e
      }
    }, void 0, void 0, !0);
  },
  getReportInfoParams: function getReportInfoParams(e) {
    return ee.post(te("ChromelessReports/GetReportInfoParams"), {
      Model: e
    }, void 0, void 0, !0);
  },
  getYieldByAnalysisInfo: function getYieldByAnalysisInfo(e) {
    return ee.post(te("ChromelessReports/GetYieldByAnalysisInfo"), {
      Model: e
    }, void 0, void 0, !0);
  },
  getYieldByMapInfo: function getYieldByMapInfo(e) {
    return ee.post(te("ChromelessReports/GetYieldByMapInfo"), {
      Model: e
    }, void 0, void 0, !0);
  },
  getScoutingEventInfo: function getScoutingEventInfo(e) {
    return ee.post(te("ChromelessReports/GetScoutingEventInfo"), {
      Model: e
    }, void 0, void 0, !0);
  },
  getTruYieldSummaryInfo: function getTruYieldSummaryInfo(e) {
    return ee.post(te("ChromelessReports/GetTruYieldSummaryInfo"), {
      Model: e
    }, void 0, void 0, !0);
  },
  getTruYieldImpactInfo: function getTruYieldImpactInfo(e) {
    return ee.post(te("ChromelessReports/GetTruYieldImpactInfo"), {
      Model: e
    }, void 0, void 0, !0);
  },
  getProductRecSummaryInfo: function getProductRecSummaryInfo(e, t, o, r) {
    return ee.post(te("ChromelessReports/GetProductRecSummaryInfo"), {
      Model: {
        companyGuid: e,
        recGeneralGuidList: t,
        showCostDetail: o,
        reportGuid: r
      }
    }, void 0, void 0, !0);
  },
  getExtractorSummaryInfo: function getExtractorSummaryInfo(e, t, o) {
    return ee.post(te("ChromelessReports/GetExtractorSummaryInfo"), {
      Model: {
        agEventGuidList: e,
        customerGuidList: t,
        reportGuid: o
      }
    }, void 0, void 0, !0);
  },
  getInspexReportInfo: function getInspexReportInfo(e, t, o) {
    return ee.post(te("ChromelessReports/GetInspexReportInfo"), {
      Model: {
        selectedAgEventGuids: e,
        selectedFieldGuids: t,
        loggedInUserGuid: o
      }
    }, void 0, void 0, !0);
  },
  getHarvestSummaryMultiSeasonInfo: function getHarvestSummaryMultiSeasonInfo(e, t, o, r, i, a) {
    return ee.post(te("ChromelessReports/GetHarvestSummaryMultiSeasonInfo"), {
      Model: {
        customerName: e,
        customerGuid: t,
        selectedEventGuids: o,
        groupByField: r,
        groupByCrop: i,
        reportGuid: a
      }
    }, void 0, void 0, !0);
  },
  getSkyProductRecSummaryInfo: function getSkyProductRecSummaryInfo(e) {
    return ee.post(te("ChromelessReports/GetSkyProductRecSummaryInfo"), {
      Model: {
        recGeneralGuidList: e
      }
    }, void 0, void 0, !0);
  },
  getSoilSampleResultsInfo: function getSoilSampleResultsInfo(e, t) {
    return ee.post(te("ChromelessReports/GetSoilSampleResultsInfo"), {
      Model: {
        companyGuid: e,
        reportGuid: t
      }
    }, void 0, void 0, !0);
  },
  getSurfaceClassBreakInfo: function getSurfaceClassBreakInfo(e) {
    return ee.post(te("ChromelessReports/GetSurfaceClassBreakInfo"), {
      Model: e
    }, void 0, void 0, !0);
  },
  getSurfaceEventLayerPoints: function getSurfaceEventLayerPoints(_ref) {
    var e = _ref.agEventGeneralGuid,
        t = _ref.agEventTransactionTypeGuid,
        o = _ref.fieldGuid,
        r = _ref.importAttributeGuid;
    return ee.post(te("ChromelessReports/GetSurfaceEventLayerPoints"), {
      Model: {
        agEventGeneralGuid: e,
        agEventTransactionTypeGuid: t,
        fieldGuid: o,
        importAttributeGuid: r
      }
    }, void 0, void 0, !0);
  },
  getCoverageSurfaceMapImage: function getCoverageSurfaceMapImage(e, t) {
    return ee.post(te("ChromelessReports/getCoverageSurfaceMapImage"), {
      Model: {
        surfaceRendererGuid: e,
        surfaceTypeName: t
      }
    }, void 0, void 0, !0);
  },
  getApplicationMapInfo: function getApplicationMapInfo(e) {
    return ee.post(te("ChromelessReports/GetApplicationMapInfo"), {
      Model: e
    }, void 0, void 0, !0);
  }
}),
    pe = Object.freeze({
  __proto__: null,
  fetchRegistrationUrl: function fetchRegistrationUrl(e) {
    return ee.get(te("Climate/RegistrationUrl?userGuid=".concat(e)));
  }
}),
    Ae = oe("user", "v1.0"),
    me = Object.freeze({
  __proto__: null,
  getColorOverrides: function getColorOverrides(e) {
    return ee.get(Ae("login/".concat(e, "/color-overrides")));
  },
  getColorOverrideTypes: function getColorOverrideTypes() {
    return ee.get(Ae("color-override/types"));
  },
  saveColorOverrides: function saveColorOverrides(e, t) {
    return ee.put(Ae("login/".concat(e, "/color-override")), t);
  },
  deleteColorOverrides: function deleteColorOverrides(e, t) {
    return ee.delete(Ae("login/".concat(e, "/color-override")), t);
  }
}),
    ye = Object.freeze({
  __proto__: null,
  getPhotoMediaTypeGuid: function getPhotoMediaTypeGuid() {
    return ee.get(te("ImageUtility/GetPhotoMediaTypeGuid"));
  }
}),
    ge = Object.freeze({
  __proto__: null,
  fetchRegistrationUrl: function fetchRegistrationUrl(e, t) {
    return null != t ? ee.get(te("JohnDeere/RegistrationUrl?userGuid=".concat(e, "&state=").concat(t))) : ee.get(te("JohnDeere/RegistrationUrl?userGuid=".concat(e)));
  },
  fetchSelectOrganizationsUrl: function fetchSelectOrganizationsUrl(e) {
    return null != e ? ee.get(te("JohnDeere/SelectOrganizationsUrl?state=".concat(e))) : ee.get(te("JohnDeere/SelectOrganizationsUrl"));
  },
  fetchExistingRefreshToken: function fetchExistingRefreshToken(e) {
    return ee.get(te("JohnDeere/ExistingRefreshToken?userGuid=".concat(e)));
  },
  exchangeForRefreshToken: function exchangeForRefreshToken(e) {
    var t = {
      authorizationCode: e
    };
    return ee.post(te("JohnDeere/ExchangeForRefreshToken"), t);
  },
  exchangeForAccessToken: function exchangeForAccessToken(e) {
    var t = {
      refreshToken: e
    };
    return ee.post(te("JohnDeere/ExchangeForAccessToken"), t);
  },
  saveRefreshToken: function saveRefreshToken(e, t) {
    var o = {
      userGuid: e,
      refreshToken: t
    };
    return ee.post(te("JohnDeere/SaveRefreshToken"), o);
  }
}),
    fe = {
  ANALYSIS: 0,
  EVENT_IMPORTED: 1,
  EVENT_FROM_EQUATION_REC: 8,
  EVENT_MANUAL: 2,
  REC: 3,
  SOIL: 4,
  IMAGERY: 5,
  MANAGEMENT_AREA: 6,
  UNKNOWN: 7
},
    getAttributeGuidFieldName = function getAttributeGuidFieldName(e) {
  switch (e) {
    case fe.MANAGEMENT_AREA:
    case fe.SOIL:
    case fe.EVENT_IMPORTED:
    case fe.EVENT_FROM_EQUATION_REC:
      return "importAttributeGuid";

    case fe.EVENT_MANUAL:
      return "eventAttributeGuid";

    case fe.REC:
      return "nutrientGuid";

    case fe.IMAGERY:
      return "imageryLayerGuid";

    default:
      return "surfaceRendererGuid";
  }
},
    getLayerType = function getLayerType(e) {
  return e.agEventGeneralGuid && e.isManual ? fe.EVENT_MANUAL : e.agEventGeneralGuid && e.isFromEquationRec ? fe.EVENT_FROM_EQUATION_REC : !e.agEventGeneralGuid || e.isManual || e.isFromEquationRec ? e.analysisLayerGuid && e.isManagementArea ? fe.MANAGEMENT_AREA : e.analysisLayerGuid ? fe.ANALYSIS : e.recGeneralGuid ? fe.REC : e.soilsFieldGuid ? fe.SOIL : e.imageryLayerGuid ? fe.IMAGERY : fe.UNKNOWN : fe.EVENT_IMPORTED;
},
    getSurfaceInfoIndex = function getSurfaceInfoIndex(e, t, o, r) {
  var i = getLayerType(e),
      a = getAttributeGuidFieldName(i);

  switch (i) {
    case fe.MANAGEMENT_AREA:
      return t ? e.subLayers.findIndex(function (e) {
        return e.surfaceGuid === t;
      }) : o ? e.subLayers.findIndex(function (e) {
        return e.importAttributeGuid === o;
      }) : e.subLayers.findIndex(function (t) {
        return t.surfaceGuid === e.selectedSurfaceGuid;
      });

    case fe.ANALYSIS:
      return "Imagery Setup - Sentinel 2" === e.layerType ? o ? e.subLayers.findIndex(function (e) {
        return e.surfaceRendererGuid === o;
      }) : e.subLayers.findIndex(function (e) {
        return e.surfaceGuid === t;
      }) : e.subLayers.findIndex(function (e) {
        return e.surfaceTypeGuid === e.selectedSurfaceTypeGuid;
      });

    case fe.EVENT_FROM_EQUATION_REC:
    case fe.EVENT_IMPORTED:
      {
        if (e.isSampling) return "5a3p1e-51t35-9u1d" === t ? -2 : e.subLayers ? e.subLayers.findIndex(function (i) {
          return i.surfaceGuid === t && (!o || i[a] === o) && i.surfaceTypeGuid === (r || e.selectedSurfaceTypeGuid);
        }) : -2;

        var _i2 = e.subLayers.findIndex(function (e) {
          return (!t || e.surfaceGuid === t) && e.surfaceTypeGuid === (r || e.selectedSurfaceTypeGuid);
        });

        return _i2 < 0 && (_i2 = t ? e.subLayers.findIndex(function (e) {
          return t && e.surfaceGuid === t;
        }) : e.subLayers.findIndex(function (t) {
          return t.surfaceTypeGuid === (r || t.selectedSurfaceTypeGuid) && t[a] === (o || e.selectedAttributeGuid);
        })), _i2;
      }

    case fe.EVENT_MANUAL:
    case fe.REC:
      var _i = e.subLayers.findIndex(function (e) {
        return (!t || e.surfaceGuid === t) && e.surfaceTypeGuid === (r || e.selectedSurfaceTypeGuid);
      });

      return _i < 0 && !t && (_i = e.subLayers.findIndex(function (t) {
        return t.surfaceTypeGuid === (r || e.selectedSurfaceTypeGuid) && t[a] === (o || e.selectedAttributeGuid);
      })), _i;

    case fe.SOIL:
      return e.subLayers.findIndex(function (t) {
        return t[a] === (o || e.selectedAttributeGuid);
      });

    case fe.IMAGERY:
      return 0;

    default:
      return -1;
  }
},
    be = Object.freeze({
  __proto__: null,
  SAMPLE_SITES_GUID: "5a3p1e-51t35-9u1d",
  LayerType: fe,
  getAttributeGuidFieldName: getAttributeGuidFieldName,
  getLayerType: getLayerType,
  getManualSurfaceChangeRequest: function getManualSurfaceChangeRequest(e, t, o, r, i) {
    var a = getLayerType(t),
        l = t.recGeneralGuid,
        s = t.recName,
        n = o.agEventGeneralGuid,
        d = o.agEventTransactionTypeGuid,
        c = o.classificationMethodGuid,
        u = o.colorRampGuid,
        p = o.numberOfClasses,
        A = o.nutrientGuid,
        m = o.selectedSurfaceTypeGuid,
        y = o.surfaceGuid,
        g = o.surfaceRendererGuid,
        f = o.surfaceType,
        b = o.surfaceTypeDisplayName;
    return {
      agEventGeneralGuid: n,
      agEventTransactionTypeGuid: d,
      classificationMethodGuid: c,
      colorRampGuid: u,
      colorSchemeGuid: i,
      numberOfClasses: p,
      nutrientGuid: A,
      recGeneralGuid: l,
      recName: s,
      selectedAttributeGuid: r,
      selectedSurfaceTypeGuid: m,
      selectedSurfaceGuid: y,
      soilsFieldGuid: a === fe.SOIL ? e : null,
      surfaceGuid: y,
      surfaceRendererGuid: g,
      surfaceType: f,
      surfaceTypeDisplayName: b
    };
  },
  getOtherSurface: function getOtherSurface(e, t, o, r) {
    var i = getLayerType(e),
        a = getAttributeGuidFieldName(i),
        l = i === fe.REC ? t[a] : o;
    if (t[a] === l && t.surfaceTypeGuid === r) return t;
    if (e.subLayers.filter(function (e) {
      return e[a] === l && e.surfaceTypeGuid === r;
    }).length > 1) throw new Error("'".concat(a, "' and 'surfaceTypeGuid' identify multiple sublayers for layer '").concat(e.displayName, "'"));
    return e.subLayers.find(function (e) {
      return e[a] === l && e.surfaceTypeGuid === r;
    });
  },
  getSlimLayerInfo: function getSlimLayerInfo(e) {
    return {
      agEventGeneralGuid: e.agEventGeneralGuid,
      fieldGuid: e.fieldGuid
    };
  },
  getSlimSurfaceInfo: function getSlimSurfaceInfo(_ref2) {
    var e = _ref2.agEventGeneralGuid,
        t = _ref2.agEventTransactionTypeGuid,
        o = _ref2.classBreaks,
        r = _ref2.classificationMethodGuid,
        i = _ref2.colorRampGuid,
        a = _ref2.depthId,
        l = _ref2.imageryLayerGuid,
        s = _ref2.importFileGuid,
        n = _ref2.importAttributeGuid,
        d = _ref2.numberOfClasses,
        c = _ref2.surfaceGuid,
        u = _ref2.surfaceRendererGuid,
        p = _ref2.surfaceRendererVectorGuid,
        A = _ref2.surfaceType;
    return {
      agEventGeneralGuid: e,
      agEventTransactionTypeGuid: t,
      classBreaks: o,
      classificationMethodGuid: r,
      colorRampGuid: i,
      depthId: a,
      imageryLayerGuid: l,
      importFileGuid: s,
      importAttributeGuid: n,
      numberOfClasses: d,
      rendererGuid: u,
      surfaceGuid: c,
      surfaceType: A,
      vectorGuid: p
    };
  },
  getSurfaceChangeRequest: function getSurfaceChangeRequest(e, t, o, _ref3) {
    var r = _ref3.attributeGuid,
        i = _ref3.classificationMethodGuid,
        a = _ref3.colorRampGuid,
        l = _ref3.colorSchemeGuid,
        s = _ref3.numberOfClasses,
        n = _ref3.surfaceTypeGuid;
    var d = getLayerType(t);
    console.assert(!t.isManual);
    var c = t.recGeneralGuid,
        u = t.recName,
        p = o.agEventGeneralGuid,
        A = o.agEventTransactionTypeGuid,
        m = o.analysisLayerGuid,
        y = o.nutrientGuid,
        g = o.surfaceGuid,
        f = o.surfaceRendererGuid,
        b = o.surfaceType,
        S = o.surfaceTypeDisplayName;
    return {
      agEventGeneralGuid: p,
      agEventTransactionTypeGuid: A,
      analysisLayerGuid: m,
      classificationMethodGuid: i,
      colorRampGuid: a,
      colorSchemeGuid: l,
      numberOfClasses: s,
      nutrientGuid: y,
      recGeneralGuid: c,
      recName: u,
      selectedAttributeGuid: d === fe.REC ? null : r,
      selectedSurfaceTypeGuid: n,
      soilsFieldGuid: null,
      surfaceGuid: g,
      surfaceRendererGuid: f,
      surfaceType: b,
      surfaceTypeDisplayName: S
    };
  },
  getSurfaceInfo: function getSurfaceInfo(e, t, o, r) {
    var i = getSurfaceInfoIndex(e, t, o, r);
    return -2 === i ? {} : i >= 0 ? e.subLayers[i] : null;
  },
  getSurfaceInfoIndex: getSurfaceInfoIndex
}),
    Se = Object.freeze({
  __proto__: null
}),
    Ge = oe("notification", "v1.0"),
    Ie = Object.freeze({
  __proto__: null,
  fetchUserNotifications: function fetchUserNotifications(e) {
    var t = new re();
    return t.append("UserGuid", e), t.append("Past", "30.00:00:00.0000001"), ee.get(Ge("", t.toString()), null, e);
  },
  updateNotificationsRead: function updateNotificationsRead(e, t) {
    var o = {
      "user-guid": e
    };
    return ee.patch(Ge("/read", null), t, "application/json", o);
  }
}),
    he = Object.freeze({
  __proto__: null,
  parsePicklistResp: function parsePicklistResp(e) {
    return e.sort(function (e, t) {
      return Number(e.sortOrder) < Number(t.sortOrder) ? -1 : 1;
    }), e.map(function (e) {
      return {
        label: e.value,
        value: e.picklistValueGuid,
        activeYn: e.activeYn,
        sortOrder: e.sortOrder
      };
    });
  },
  getCategories: function getCategories(e, t) {
    return ee.post(te("Picklist/GetCategoryList"), {
      UserGuid: e,
      Model: t
    });
  },
  getPicklistNames: function getPicklistNames(e, t, o, r) {
    var i = {
      picklistNameGuid: t,
      picklistCategoryGuid: o,
      searchValue: r
    };
    return ee.post(te("Picklist/GetPicklistNameList"), {
      UserGuid: e,
      Model: i
    });
  },
  getPicklistParentValueList: function getPicklistParentValueList(e, t) {
    return ee.post(te("Picklist/GetPicklistParentValueList"), {
      UserGuid: e,
      Model: t
    });
  },
  getPicklistValues: function getPicklistValues(e, t) {
    return ee.post(te("Picklist/GetPicklistValuesList"), {
      UserGuid: e,
      Model: t
    });
  },
  getPicklistValuesById: function getPicklistValuesById(e, t) {
    return ee.post(te("Picklist/GetPicklistValuesById"), {
      UserGuid: e,
      Model: t
    });
  },
  getPicklistChildList: function getPicklistChildList(e, t) {
    return ee.post(te("Picklist/GetPicklistChildList"), {
      UserGuid: e,
      Model: t
    });
  },
  getFilteredChildPicklist: function getFilteredChildPicklist(e, t) {
    return ee.post(te("Picklist/GetPicklistChildValueList"), {
      UserGuid: e,
      Model: t
    });
  },
  getUnitPicklistBySystemAttributeAndEventType: function getUnitPicklistBySystemAttributeAndEventType(e, t, o) {
    var r = {
      systemAttribute: t,
      eventType: o
    };
    return ee.post(te("Picklist/GetUnitPicklistBySystemAttributeAndEventType"), {
      UserGuid: e,
      Model: r
    });
  },
  GetUnitPicklistByUnitTypeId: function GetUnitPicklistByUnitTypeId(e, t) {
    return ee.post(te("Picklist/GetUnitPicklistByUnitTypeId"), {
      UserGuid: e,
      Model: t
    });
  },
  getPicklist: function getPicklist(e, t) {
    return ee.post(te("AgBytes/GetPicklist"), {
      UserGuid: e,
      Model: t
    });
  },
  getNextPicklistValueId: function getNextPicklistValueId(e, t) {
    return ee.post(te("AgBytes/GetNextPicklistValueId"), {
      UserGuid: e,
      Model: t
    });
  },
  addPicklist: function addPicklist(e, t) {
    return ee.post(te("AgBytes/AddPicklist"), {
      UserGuid: e,
      Model: t
    });
  },
  updatePicklist: function updatePicklist(e, t) {
    return ee.post(te("AgBytes/UpdatePicklist"), {
      UserGuid: e,
      Model: t
    });
  },
  getUnitListByType: function getUnitListByType(e, t) {
    return ee.post(te("AgBytes/GetUnitListByType"), {
      UserGuid: e,
      Model: t
    });
  }
}),
    Re = Object.freeze({
  __proto__: null,
  QueueStatusGroupName: {
    EVENTS: "Events",
    EXPORTS: "Exports",
    FIELDS: "Fields",
    IMPORTS: "Imports",
    RECS: "Recs",
    REPORTS: "Reports"
  },
  QueueStatusState: {
    ACTIVE: "ACTIVE",
    PENDING: "PENDING"
  },
  getCurrentQueueStatus: function getCurrentQueueStatus(e) {
    return ee.post(te("User/GetQueueProcessingStats"), {
      UserGuid: e
    });
  }
}),
    Pe = oe("reportbook", "v1.0"),
    we = Object.freeze({
  __proto__: null,
  deactivateReportBooks: function deactivateReportBooks(e) {
    return ee.post(Pe("deactivate"), {
      reportBookGuids: e
    });
  },
  getReportBooks: function getReportBooks(e, t) {
    var o = new re();
    return e.length > 0 ? (o.append("fieldGuids", e), o.append("filterOptions", btoa(JSON.stringify(t))), ee.get(Pe("", o.toString()))) : ee.get(Pe(""));
  },
  getReportBooksAutoComplete: function getReportBooksAutoComplete(e, t, o, r) {
    var i = new re();
    return e.length > 0 ? (i.append("fieldGuids", e), i.append("filterOptions", btoa(JSON.stringify(t))), i.append("searchName", o), i.append("searchString", r), ee.get(Pe("autoComplete", i.toString()))) : ee.get(Pe("autoComplete"));
  },
  mergeReportBook: function mergeReportBook(e) {
    var t = le();
    return ee.put(Pe("".concat(t)), e).then(function () {
      return {
        reportBookGuid: t,
        trackingGuid: e.trackingGuid
      };
    });
  }
}),
    Le = oe("reportbook", "v1.0"),
    ve = Object.freeze({
  __proto__: null,
  copyReportBookCoverPageFile: function copyReportBookCoverPageFile(e) {
    return ee.post(te("Reports/copyReportBookCoverPageFile"), {
      fromKey: e
    });
  },
  deactivateReportBookType: function deactivateReportBookType(e) {
    return ee.post(Le("type/deactivate/".concat(e)), null);
  },
  deactivateReportOption: function deactivateReportOption(e) {
    return ee.post(Le("option/deactivate/".concat(e)), null);
  },
  deleteReportBookCoverPageFilesFromS3: function deleteReportBookCoverPageFilesFromS3(e) {
    return ee.post(te("Reports/DeleteReportBookCoverPageFileFromS3"), {
      fileNames: e
    });
  },
  getReportBookCoverPageS3PresignedUrl: function getReportBookCoverPageS3PresignedUrl(e) {
    return ee.post(te("Reports/GetReportBookCoverPageS3PresignedUrl"), {
      fileName: e
    });
  },
  getReportBookOrgLevelGuids: function getReportBookOrgLevelGuids(e) {
    return ee.get(Le("orgLevelGuid/".concat(e)));
  },
  getReportBookReports: function getReportBookReports(e) {
    return ee.get(Le("report/".concat(e)));
  },
  getReportBookTypesFromOption: function getReportBookTypesFromOption(e) {
    return ee.get(Le("option/deactivate/".concat(e)));
  },
  getReportBookTypeNames: function getReportBookTypeNames(e) {
    var t = new re();
    return t.append("companyGuid", e), ee.get(Le("type/name", t.toString()));
  },
  getReportBookTypes: function getReportBookTypes(e, t, o) {
    var r = new re();
    return r.append("companyGuid", t), r.append("includeInactive", e ? "1" : "0"), null != o && r.append("locationGuid", o), ee.get(Le("type", r.toString()));
  },
  getReportOptions: function getReportOptions(e, t, o) {
    var r = new re();
    return r.append("companyGuid", t), null != o && r.append("locationGuid", o), e ? ee.get(Le("option/".concat(e), r.toString())) : ee.get(Le("option", r.toString()));
  },
  getReportTypes: function getReportTypes() {
    return ee.get(Le("reportType"));
  },
  getSoilTypeAttributes: function getSoilTypeAttributes() {
    return ee.get(Le("soilTypeAttribute"));
  },
  mergeReportBookType: function mergeReportBookType(e) {
    return e.reportBookTypeGuid || (e.reportBookTypeGuid = le()), ee.put(Le("type/".concat(e.reportBookTypeGuid)), e).then(function () {
      return e.reportBookTypeGuid;
    });
  },
  mergeReportBookOptions: function mergeReportBookOptions(e) {
    return e.reportBookOptionsGuid || (e.reportBookOptionsGuid = le()), ee.put(Le("option/".concat(e.reportBookOptionsGuid)), e).then(function () {
      return e.reportBookOptionsGuid;
    });
  }
}),
    Te = Object.freeze({
  __proto__: null,
  searchVarietyHybrid: function searchVarietyHybrid(e, t) {
    return ee.post(te("AgBytes/GetVarietyHybridSearch"), {
      UserGuid: e,
      Model: t
    });
  }
});

var Me = Object.freeze({
  __proto__: null,
  DTNMarketPrice: /*#__PURE__*/function () {
    function DTNMarketPrice(e) {
      _classCallCheck(this, DTNMarketPrice);

      this.baseUrl = "https://api.dtn.com/markets/price-history?symbol=", this.paramsUrl = "&interval=D&duration=365-D&apikey=", this.credentials = e;
    }

    _createClass(DTNMarketPrice, [{
      key: "getMarketCropYearHighLowPrice",
      value: function getMarketCropYearHighLowPrice(e) {
        return this._fetchData(e);
      }
    }, {
      key: "_fetchData",
      value: function _fetchData(e) {
        var _this = this;

        return new Promise(function (t, o) {
          var r = "".concat(_this.baseUrl).concat(e).concat(_this.paramsUrl).concat(_this.credentials),
              i = new URL(r);
          fetch(i.href).then(function (e) {
            return e.json().then(function (e) {
              return t(e);
            });
          }).catch(function (e) {
            return o(e);
          });
        });
      }
    }]);

    return DTNMarketPrice;
  }()
}),
    Ce = oe("credit", "v1.0"),
    Ee = Object.freeze({
  __proto__: null,
  options: function () {
    var _options = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      var t, o;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return ee.get(Ce("option?RecNutrientGuid=".concat(e)), null, null, null);

            case 2:
              t = _context.sent;
              o = se.partition(t, function (e) {
                return "Rec" === e.type;
              });
              return _context.abrupt("return", {
                availableRecCredits: o[0],
                availableApplicationCredits: o[1]
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function options(_x) {
      return _options.apply(this, arguments);
    }

    return options;
  }()
});
var Be;
!function (e) {
  e.DYNAMIC = "Dynamic", e.LANDSCAPE = "Landscape", e.PORTRAIT = "Portrait";
}(Be || (Be = {}));
var Ne = {
  fieldBoundary: 0,
  observations: 1,
  samplePoints: 2,
  surface: 3,
  polygonGraphics: 4,
  uniquePolygonGraphics: 5,
  nonFieldFeatures: 6,
  multiFieldImagery: 7,
  imagery: 8,
  userDefinedPolygon: 9,
  customGraphics: 10
};
var xe, Ue;
!function (e) {
  e.LANDSCAPE = "Landscape", e.PORTRAIT = "Portrait";
}(xe || (xe = {})), function (e) {
  e.Letter = "letter", e.Ledger = "ledger", e.ArchD = "archd", e.ArchE = "arche", e.ReallyBig = "reallybig";
}(Ue || (Ue = {}));

var ke = Object.freeze({
  __proto__: null,

  get CropMapOrientation() {
    return Be;
  },

  layerType: Ne,
  PageDimensions: {
    letter: {
      label: '8.5" x 11"',
      width: "8.5in",
      length: "11in"
    },
    ledger: {
      label: '11" x 17"',
      width: "11in",
      length: "17in"
    },
    archd: {
      label: '24" x 36"',
      width: "24in",
      length: "36in"
    },
    arche: {
      label: '36" x 48"',
      width: "36in",
      length: "48in"
    },
    reallybig: {
      label: '48" x 60"',
      width: "48in",
      length: "60in"
    }
  },

  get PageOrientation() {
    return xe;
  },

  get PageSizes() {
    return Ue;
  },

  ZoomLevelDetails: {
    1: {
      factor: 1,
      label: "100%"
    },
    2: {
      factor: 1.5,
      label: "150%"
    },
    3: {
      factor: 2,
      label: "200%"
    },
    4: {
      factor: 2.5,
      label: "250%"
    },
    5: {
      factor: 3,
      label: "300%"
    },
    6: {
      factor: 4,
      label: "400%"
    },
    7: {
      factor: 5,
      label: "500%"
    },
    8: {
      factor: 6,
      label: "600%"
    },
    9: {
      factor: 7,
      label: "700%"
    },
    10: {
      factor: 8,
      label: "800%"
    }
  }
}),
    createSimpleLineSymbolJSON = function createSimpleLineSymbolJSON(e, t) {
  var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "esriSLSSolid";
  return {
    color: e,
    style: o,
    type: "esriSLS",
    width: t
  };
},
    createLabelValueExpression = function createLabelValueExpression(e) {
  return {
    expression: e
  };
},
    JSONUtils_createPictureMarkerSymbolJSON = function JSONUtils_createPictureMarkerSymbolJSON(e, t, o, r, i, a, l) {
  var s = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
  var n = t ? {
    contentType: o,
    imageData: e
  } : {
    url: e
  };
  return Object.assign(n, {
    angle: s,
    height: i,
    type: "esriPMS",
    width: r,
    xoffset: a,
    yoffset: l
  });
},
    JSONUtils_createSimpleFillSymbolJSON = function JSONUtils_createSimpleFillSymbolJSON(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : e;
  var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "esriSLSSolid";
  var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "esriSFSSolid";
  return {
    color: e,
    outline: createSimpleLineSymbolJSON(t, o, r),
    style: i,
    type: "esriSFS"
  };
},
    Oe = createSimpleLineSymbolJSON,
    JSONUtils_createSimpleMarkerSymbolJSON = function JSONUtils_createSimpleMarkerSymbolJSON(e, t) {
  var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "esriSMSCircle";
  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var a = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [0, 0, 0];
  var l = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 1;
  var s = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
  return {
    angle: s,
    color: e,
    size: t,
    style: o,
    type: "esriSMS",
    outline: createSimpleLineSymbolJSON(a, l),
    xoffset: r,
    yoffset: i
  };
},
    JSONUtils_createTextSymbolJSON = function JSONUtils_createTextSymbolJSON() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [255, 255, 255, 255];
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Arial";
  var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 12;
  var r = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var i = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var a = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "normal";
  var l = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : "bolder";
  var s = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : [0, 0, 0, 175];
  var n = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 1;
  var d = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : "center";
  return {
    angle: 0,
    color: e,
    font: {
      family: t,
      size: o,
      style: a,
      weight: l,
      decoration: "none"
    },
    haloColor: s,
    haloSize: n,
    horizontalAlignment: d,
    kerning: !0,
    rightToLeft: !1,
    type: "esriTS",
    verticalAlignment: "middle",
    xoffset: r,
    yoffset: i
  };
},
    JSONUtils_createLabelJSON = function JSONUtils_createLabelJSON(e, t, o, r, i, a) {
  return {
    labelExpressionInfo: createLabelValueExpression(t),
    symbol: e,
    fieldInfos: i,
    labelPlacement: o,
    sizeInfo: a,
    where: r
  };
},
    ze = {
  fontStyle: {
    display: "none"
  },
  positionStyle: void 0
},
    je = {
  color: "white",
  fontFamily: "'Arial'",
  fontSize: "12px",
  textAlign: "center"
},
    De = {
  fontFamily: "'Arial'",
  color: "black",
  textAlign: "center",
  textShadow: "0px 0px rgba(0, 0, 0, 0)"
},
    Fe = {
  position: "absolute",
  display: "flex",
  flexDirection: "column",
  overflow: "visible",
  minWidth: "1px",
  minHeight: "1px",
  maxWidth: "1px",
  maxHeight: "1px"
},
    Ze = {
  labelAnchorCenter: _objectSpread(_objectSpread({}, Fe), {}, {
    justifyContent: "center",
    alignItems: "center"
  }),
  labelAnchorCenterLeft: _objectSpread(_objectSpread({}, Fe), {}, {
    justifyContent: "center",
    alignItems: "flex-start"
  }),
  labelAnchorCenterTop: _objectSpread(_objectSpread({}, Fe), {}, {
    justifyContent: "flex-start",
    alignItems: "center"
  }),
  labelAnchorLowerLeft: _objectSpread(_objectSpread({}, Fe), {}, {
    justifyContent: "flex-end",
    alignItems: "flex-start"
  }),
  labelAnchorBelowCenter: _objectSpread(_objectSpread({}, Fe), {}, {
    flexDirection: "column-reverse",
    justifyContent: "flex-end",
    alignItems: "center"
  })
},
    Je = {
  labels: {
    off: {
      show: !1
    },
    on: {
      lineHeight: 13,
      show: !0,
      symbol: JSONUtils_createTextSymbolJSON([255, 255, 255, 255], "Arial", 10, 0, 0, "normal", "normal", [0, 0, 0, 180], 0)
    },
    agvanceSkyDefault: {
      lineHeight: 13,
      show: !0,
      symbol: JSONUtils_createTextSymbolJSON([0, 0, 0, 255], "Arial", 7, 0, 0, "normal", "normal", [0, 0, 0, 180], 0)
    },
    cropMap: {
      lineHeight: 13,
      show: !0,
      symbol: JSONUtils_createTextSymbolJSON([0, 0, 0, 255], "Arial", 7, 0, 0, "normal", "normal", [0, 0, 0, 180], 0)
    },
    truYieldCropMap: {
      lineHeight: 11,
      show: !0,
      symbol: JSONUtils_createTextSymbolJSON([0, 0, 0, 255], "Calibri", 7, 0, 0, "normal", "normal", [0, 0, 0, 180], 0)
    },
    boundaryMap: {
      lineHeight: 13,
      show: !0,
      symbol: JSONUtils_createTextSymbolJSON([255, 255, 255, 255], "Arial", 8, 0, 0, "normal", "normal", [0, 0, 0, 180], 0)
    },
    inspex: {
      lineHeight: 13,
      show: !0,
      symbol: JSONUtils_createTextSymbolJSON([255, 255, 255, 255], "Arial", 8, 0, 0, "normal", "normal", [0, 0, 0, 180], 0)
    }
  },
  labelStyles: {
    off: ze,
    on: {
      fontStyle: _objectSpread({}, je),
      positionStyle: Ze.labelAnchorCenter
    },
    black: {
      fontStyle: _objectSpread(_objectSpread({}, je), {}, {
        color: "black"
      }),
      positionStyle: Ze.labelAnchorCenter
    },
    cropMap: {
      fontStyle: {
        color: "black",
        fontFamily: "'Arial'",
        fontSize: "9px",
        textAlign: "center"
      },
      positionStyle: Ze.labelAnchorCenter
    },
    truYieldCropMap: {
      fontStyle: {
        color: "black",
        fontFamily: "'Calibri'",
        fontSize: "9px",
        textAlign: "center"
      },
      positionStyle: Ze.labelAnchorCenter
    }
  },
  sampleSiteLabels: {
    default: {
      altColor: [255, 140, 0],
      labels: JSONUtils_createTextSymbolJSON([0, 0, 0, 255], "Arial", 9.3, 5, 5, "normal", "normal", [0, 0, 0, 0], 0, "left"),
      points: JSONUtils_createSimpleMarkerSymbolJSON([73, 142, 226], 6, "esriSMSCircle", 0, 0, [0, 0, 0, 140], 0)
    },
    bold: {
      altColor: [255, 140, 0],
      labels: JSONUtils_createTextSymbolJSON([0, 0, 0, 255], "Arial", 16, 0, 0, "normal", "bolder", [255, 255, 255, 255], 1),
      points: JSONUtils_createSimpleMarkerSymbolJSON([73, 142, 226], 6, "esriSMSCircle", 0, 0, [0, 0, 0, 140], 0)
    },
    noSurface: {
      labels: JSONUtils_createTextSymbolJSON([0, 0, 0, 255], "Arial", 12, 0, 0, "normal", "bolder", [0, 0, 0, 180], 0),
      points: JSONUtils_createSimpleMarkerSymbolJSON([73, 142, 226], 7, "esriSMSCircle", 0, 0, [0, 0, 0, 140], 0)
    },
    directlyOnMap: {
      labels: JSONUtils_createTextSymbolJSON([255, 255, 255, 255], "Arial", 12, 0, 0, "normal", "normal", [0, 0, 0, 255], .3),
      points: JSONUtils_createSimpleMarkerSymbolJSON([73, 142, 226], 7, "esriSMSCircle", 0, 0, [0, 0, 0, 140], 0)
    },
    hiddenLabel: {
      labels: JSONUtils_createTextSymbolJSON([255, 255, 255, 0], "Arial", 12, 0, 0, "normal", "normal", [0, 0, 0, 0], 1),
      points: JSONUtils_createSimpleMarkerSymbolJSON([73, 142, 226], 7, "esriSMSCircle", 0, 0, [0, 0, 0, 140], 0)
    },
    smallLabels: {
      altColor: [255, 140, 0],
      labels: JSONUtils_createTextSymbolJSON([0, 0, 0, 255], "Arial", 7, 4, 4, "normal", "normal", [0, 0, 0, 0], 0, "left"),
      points: JSONUtils_createSimpleMarkerSymbolJSON([73, 142, 226], 6, "esriSMSCircle", 0, 0, [0, 0, 0, 140], 0)
    },
    smallPointsLabels: {
      altColor: [255, 140, 0],
      labels: JSONUtils_createTextSymbolJSON([0, 0, 0, 255], "Arial", 8, 4, 4, "normal", "normal", [0, 0, 0, 0], 0, "left"),
      points: JSONUtils_createSimpleMarkerSymbolJSON([73, 142, 226], 5, "esriSMSCircle", 0, 0, [0, 0, 0, 140], 0)
    },
    smallPointsHiddenLabels: {
      labels: JSONUtils_createTextSymbolJSON([255, 255, 255, 0], "Arial", 12, 0, 0, "normal", "normal", [0, 0, 0, 0], 1),
      points: JSONUtils_createSimpleMarkerSymbolJSON([73, 142, 226], 5, "esriSMSCircle", 0, 0, [0, 0, 0, 140], 0)
    },
    mediumPointsLabels: {
      altColor: [255, 140, 0],
      labels: JSONUtils_createTextSymbolJSON([0, 0, 0, 255], "Arial", 10, 4, 4, "normal", "normal", [0, 0, 0, 0], 0, "left"),
      points: JSONUtils_createSimpleMarkerSymbolJSON([73, 142, 226], 10, "esriSMSCircle", 0, 0, [0, 0, 0, 140], 0)
    },
    largePointLabels: {
      altColor: [255, 140, 0],
      labels: JSONUtils_createTextSymbolJSON([0, 0, 0, 255], "Arial", 16, 0, 0, "normal", "normal", [0, 0, 0, 0], 0),
      points: JSONUtils_createSimpleMarkerSymbolJSON([73, 142, 226], 13, "esriSMSCircle", 0, 0, [0, 0, 0, 140], 0)
    }
  },
  sampleSiteLabelStyles: {
    default: {
      fontStyle: _objectSpread(_objectSpread({}, De), {}, {
        fontSize: "11px",
        paddingLeft: "5px",
        paddingBottom: "4px"
      }),
      positionStyle: Ze.labelAnchorLowerLeft
    },
    bold: {
      fontStyle: _objectSpread(_objectSpread({}, De), {}, {
        fontSize: "16px",
        paddingLeft: "5px",
        paddingBottom: "4px",
        fontWeight: "bolder",
        textShadow: "1px 1px rgba(255, 255, 255, 1)"
      }),
      positionStyle: Ze.labelAnchorCenter
    },
    noSurface: {
      fontStyle: _objectSpread(_objectSpread({}, De), {}, {
        paddingLeft: "5px",
        paddingBottom: "4px",
        fontSize: "12px",
        fontWeight: "bolder"
      }),
      positionStyle: Ze.labelAnchorCenter
    },
    directlyOnMap: {
      fontStyle: _objectSpread(_objectSpread({}, De), {}, {
        paddingLeft: "5px",
        paddingBottom: "4px",
        color: "white",
        fontSize: "12px",
        textShadow: "1px 1px rgba(0, 0, 0, 1)"
      }),
      positionStyle: Ze.labelAnchorCenter
    },
    hiddenLabel: ze,
    smallLabels: {
      fontStyle: _objectSpread(_objectSpread({}, De), {}, {
        paddingLeft: "5px",
        paddingBottom: "4px",
        fontSize: "9px"
      }),
      positionStyle: Ze.labelAnchorLowerLeft
    },
    largeLabels: {
      fontStyle: _objectSpread(_objectSpread({}, De), {}, {
        fontSize: "12px",
        paddingBottom: "40px",
        paddingTop: "10px"
      }),
      positionStyle: Ze.labelAnchorCenter
    },
    printLayer: {
      fontStyle: {
        fontFamily: "'Arial'",
        fontWeight: "normal",
        fontSize: "12px",
        color: "white",
        textShadow: "0 0 0.08em black, 0 0 0.08em black, 0 0 0.08em black, 0 0 0.08em black, 0 0 0.08em black, 0 0 0.08em black",
        textAlign: "left",
        paddingLeft: "8px",
        paddingBottom: "4px"
      },
      positionStyle: Ze.labelAnchorLowerLeft
    },
    productivityLabels: {
      fontStyle: _objectSpread(_objectSpread({}, De), {}, {
        fontSize: "12px",
        paddingTop: "9px"
      }),
      positionStyle: Ze.labelAnchorBelowCenter
    }
  },
  symbols: {
    fieldBoundary: {
      brown: JSONUtils_createSimpleFillSymbolJSON([137, 105, 66, 255], [85, 65, 40, 200], .1),
      gray: JSONUtils_createSimpleFillSymbolJSON([0, 0, 0, 0], [200, 200, 200, 200], 2),
      red: JSONUtils_createSimpleFillSymbolJSON([0, 0, 0, 0], [230, 0, 0, 200], 2.5),
      white: JSONUtils_createSimpleFillSymbolJSON([0, 0, 0, 0], [255, 255, 255, 200], 2),
      whiteThin: JSONUtils_createSimpleFillSymbolJSON([0, 0, 0, 0], [255, 255, 255, 200], 1),
      yellow: JSONUtils_createSimpleFillSymbolJSON([0, 0, 0, 0], [255, 255, 0, 200], 2.5)
    },
    observations: {
      clusterLabelingMeters: 5,
      default: {
        point: JSONUtils_createPictureMarkerSymbolJSON("iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAZdEVYdFNvZnR3YXJlAEFkb2JlIEltYWdlUmVhZHlxyWU8AAADImlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS4wLWMwNjAgNjEuMTM0Nzc3LCAyMDEwLzAyLzEyLTE3OjMyOjAwICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ1M1IE1hY2ludG9zaCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoyMjg2RTIxOUQyNzExMUUwQUU5NUVFMEYwMTY0NzUwNSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDoyMjg2RTIxQUQyNzExMUUwQUU5NUVFMEYwMTY0NzUwNSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjIyODZFMjE3RDI3MTExRTBBRTk1RUUwRjAxNjQ3NTA1IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjIyODZFMjE4RDI3MTExRTBBRTk1RUUwRjAxNjQ3NTA1Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+eZs/SwAACWFJREFUeF7tWgtsjWcY/lstcy91aSltMbTutwoZMYnZhCXTNWJzyS6siIS4h7hsbdlYql3XxbbMpVusGDZEk859wYIxtyGYJmouoW69RPHueb7838nf01OnF/5zpOckT85/vv/6Pu/zXv7vO4aIGNUZ1dp4Ot5HQHWWv08BvhDw5QBfEvRVAV8V8HWCvla4WueBam18pTtB4yX4lDe5V0oBL4H95bar3AdaGbUS0KhRI6N58+ZGy5YtjcjISKN9+/ZGdHS00aVLF6NHjx5Gr169jN69ext9+vRRKCwsjHz8+PE7T548WVJcXPypRkFBQezNmzfb4toBgD/gRzRo0MCoU6eOUbNmTSMwMNAICAgw/P39Ffz8eIjrj20KaNasWQnjO3XqZHTt2tXo2bOnMjgmJkYZjQdKfvr06RV8P/MDYnIePHiQfvjw4SiYVsskRJFB42vUqOFdBLRo0cKIiIhweN5qPA2HQWtoMYySDRs2yNy5c2Xw4MECdQiOlc6dO0vHjh0FSpHJkyfL6tWr5d69e4okfP+8bdu2rjC+DhColeHO+9SEbQpo3bq10bZtWyMqKqqE5ylzPEQeDU9KSpK+ffsK1CAIhxLG4zxB2EibNm0kPDxcEEqCkJLp06fL3bt3Bde5f/z48Y9gU2OTCIZI2do3I8I2Ahj3HTp0MOBJFfN8OMY3PXjgwAEZMmSIMh7hoLzcvXt3QX4Q5AnBedKuXTvBNQRECtQkISEhEhwcLEFBQWpsx44dSg2XL19Ow7VDgfpATUuecJkEbCOA3mfSo/Stxqemprr0OnKEkjwN114PCwuT0NBQ5fnGjRsr4+vVqye1atUSJD6ZM2eOIuHMmTPf4h7hQJCZH3SyLEWCbQQw6+vEZ8peVq5cqTxOuSMZKq8z1l3JXRtOr6OiSP369aVu3bqCrK+MR+ITxLzMmDFDkbBx48a5sJbVopGFBM8RQPmTADPT5+3bt09JXRtulTvU4ohzSh0VRMmdhqPcKa/Xrl3bYTwyvjIe5Q5TN4Zs2bJFHj58mD927Ng4kwQqgeFQKifYpgASwAeA99fev39fBg4c6Ihzq9xRKURLnYZrqWuPWw2n17XxNFyDIXHjxg05cuTIPoz1N8OBOaFUYrSNAIYAsnUbynPRokVK6jTcKned4LThVm/TKKvcteTpeavxenvMmDFCoocOHToZY73NxMgyyXzg+NhGAL2Pbi6FD0WjmeCY3Sl3ep1lzZrZnWWu49zqdS15VwRwLCcnR9Af7MX2MIANE0sk+wRHKNhKADu8devWqcxOw61lTWd2Sh0tbSlvU+pa7tZ4L8t4jicmJsqFCxfuYvsDMxTC8E0V2E8A+3fKn10cDdfNDLN7kyZNVIKzep2etnqbRmvD3XlekwL5y/Xr11llkjA23FRBkJkLVBjYpQA/xH8cCWDsU+7WssZ6zpKm63lVDdcEMGfk5uaS9I0YGwf0AUIAvjsoFdhGQH5+fiIJYJxT7trrTHTO9dxZ6uX1uKtwYB5Av/En9k0FXgcirGFgFwH+SH5LSQDLWln13NnzVTFck7F//35Zvnz5MfxmY8QwYD1uCKhqYBcBAXl5eZ+TAHf1vKJx7srr1rGLFy/KsmXLTmBsMfAu0AUIBtgT2EfAnTt3viABrur585S8MyHnz5+XhISEkxhPBN4D+CbW1G4CAs+dOzeeBLCl1VKvaFlz523n/ewdzp49K6NGjdqPfcuAsQCbomYA+wHbFBC4du3aXiQgNjZWlbPy1vKKGm09ftCgQXL69GmW3V89TQDjrWlRUVFuSkqKy9a1KoaWde7s2bNl9+7dBdj/o6dDgAQEX7lyJQO5wDYCONGydOnSy7j3GmAx4LEkyJLTcMGCBYMfPXok48aNe+EkjBgxQjBFxtmi33Hv7wCPlkF2XezBI5CVd7I9ZZf2ImTPazL5cb4hOTk5F783AamARxshEsD2M2TChAlvoyfIz8zMfGEErFixgvOMxfD+Xkv8e7QVZsVhHggCotLS0hI4pT1p0qTnTsLo0aPl6NGjghA4gXttAb4BZgEefRkiAToM+EraH9NWW6GE50oCjccskCD7M/HtADIAvgl6/nXYJIDNByclODkxbP369Vm3b9+WjIyMKuUExjxlT+NnzZpF43cCmUAKMI33Mu/p0QkRqoDVgMmQ8/bsyOLwwBlXr14tunTpEju2CofE8OHDZc+ePUx6xdj+2zSer7/pwDzew7wX7+nRKTEdBswFnKDkvD0nLN/HzPAKhMQ/t27dEq4TYKxcWLJkiYp3eP8/zDH8gfMoe3qexs/ntc178F6enRSl9eaHuYBT1EEA5+0HmA86Ly4u7hfO5nKu0B0JXCyh8QMGDPgLx2YBbHfZ8VH29DyN57V5D97Ls9PiFgK4yVBgWeSiBR+QSqBUp2/duvXU5s2b3RKwatUqev6aafxmfP8AfMFrmNfiNb1nYcSJAKpAk0DvUKLMCSP69es3/9q1a2qBFL9dgitITHiQPd/yaPz3wGdAPK9hXsu7lsacCOBPTQKlyfhkkuoMvAEVZGdlZZVJAKqHIP5zcOxvwBogAfiY55rX8L7FURcE6CESwcTIDM339GisGcRiJqdg5MiRpUhg1sc0VzGmztnjrwe+BLj4MZTnmtfgtbxrefwZBFjV8IppQLdNmzZlcj4Pv0tg+/btXAW+hHF2easAvuSMBLqZ5/IaZa4GOz+HXXOCbux37NZ9Qisso7956tSpW1OnTnUQEB8fL9nZ2YXwfjbO+AngLM+HwGtAK1NFJZa+3N3Y2whgOOhuMTo9PT352LFj6u2OOHjwIF+lT+MYJj72+DMB9viUfqkuz53x3O9tBPCZtAr4ztDv5MmTSgVTpkxh7OdjbBvAHp+TnON5DKCXvCrkfW8lQCfFIDxgR/xZag6ntrHGx5XeXRhj4vsKmAa8xWMAHluupOesCm9UAJ+RJNQGWM5iDh06dHbXrl3/YvtrE4vwzU4vxjyGx7r9Q5Sz8d6qAE0APcoVnFcXLlw4c+LEiSx3C0x8gu8h3GceUynvezMBmgS2y80BLmYw2THmCW5zjPscC52uPOxuzFtDQD93DWzoN8ee2ObiJsFt/YbHYyr98XYC9FwiX5qY6Sl5gtscq5L3vT0ErCqgoVQCaz3BbY5VyfsvCwFUAQ1loqPR+o/RHKtU5rfGi7eHgH5WGuoKlY59fWJ5Cfgfdfew3mnDzQQAAAAASUVORK5CYII=", !0, "image/png", 24, 24, 0, 9.5),
        polygon: JSONUtils_createSimpleFillSymbolJSON([0, 0, 0, 0], [0, 0, 0, 200], 2),
        value: null,
        weight: 0
      },
      heavy: {
        point: JSONUtils_createPictureMarkerSymbolJSON("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", !0, "image/png", 24, 24, 0, 9.5),
        polygon: JSONUtils_createSimpleFillSymbolJSON([255, 0, 0, 125], [255, 0, 0, 200], 2),
        value: "1",
        weight: 3
      },
      light: {
        point: JSONUtils_createPictureMarkerSymbolJSON("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", !0, "image/png", 24, 24, 0, 9.5),
        polygon: JSONUtils_createSimpleFillSymbolJSON([250, 225, 40, 125], [250, 225, 40, 200], 2),
        value: "2",
        weight: 1
      },
      moderate: {
        point: JSONUtils_createPictureMarkerSymbolJSON("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", !0, "image/png", 24, 24, 0, 9.5),
        polygon: JSONUtils_createSimpleFillSymbolJSON([255, 69, 0, 125], [255, 69, 0, 200], 2),
        value: "3",
        weight: 2
      },
      none: {
        point: JSONUtils_createPictureMarkerSymbolJSON("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", !0, "image/png", 24, 24, 0, 9.5),
        polygon: JSONUtils_createSimpleFillSymbolJSON([110, 175, 70, 125], [110, 175, 70, 200], 2),
        value: "4",
        weight: 4
      },
      pointLabelOnly: JSONUtils_createSimpleMarkerSymbolJSON([0, 0, 0, 0], 0, "esriSMSCircle", 0, 0, [0, 0, 0, 0], 0),
      text: {
        point: JSONUtils_createTextSymbolJSON([0, 0, 0, 255], "Arial", 9.3, 0, -5, "normal", "bold", [0, 0, 0, 0], 0),
        polygon: JSONUtils_createTextSymbolJSON([0, 0, 0, 255], "Arial", 9.3, 0, 0, "normal", "bold", [0, 0, 0, 0], 0),
        pointStyle: {
          fontStyle: _objectSpread(_objectSpread({}, De), {}, {
            fontSize: "12px",
            fontWeight: "800",
            paddingTop: "2px"
          }),
          positionStyle: Ze.labelAnchorCenterTop
        },
        polygonStyle: {
          fontStyle: _objectSpread(_objectSpread({}, De), {}, {
            fontSize: "12px",
            fontWeight: "800"
          }),
          positionStyle: Ze.labelAnchorCenter
        }
      }
    },
    polygonFeatures: {
      agvanceSkyNutrients: {
        default: JSONUtils_createSimpleFillSymbolJSON([0, 0, 0, 0], [200, 200, 200, 200], 2)
      },
      agvanceSkySoils: {
        default: JSONUtils_createSimpleFillSymbolJSON([0, 0, 0, 0], [200, 200, 200, 200], 2),
        label: {
          field: {
            name: "soilSymbol",
            type: "esriFieldTypeString"
          },
          labelClass: JSONUtils_createLabelJSON(JSONUtils_createTextSymbolJSON([0, 0, 0], "Arial", 9, 0, 0, "normal", "normal", [200, 200, 200, 150], 0), "$feature.soilSymbol")
        },
        labelStyle: {
          fontStyle: _objectSpread(_objectSpread({}, De), {}, {
            fontSize: "12px"
          }),
          positionStyle: Ze.labelAnchorCenter
        }
      },
      cropMap: {
        default: JSONUtils_createSimpleFillSymbolJSON([0, 0, 0, 0], [0, 0, 0, 200], 2),
        fillOpacity: 200,
        outlineOpacity: 256
      },
      cropMapLabel: {
        default: JSONUtils_createSimpleFillSymbolJSON([0, 0, 0, 0], [0, 0, 0, 200], 2),
        fillOpacity: 200,
        label: {
          field: {
            name: "label",
            type: "esriFieldTypeString"
          },
          labelClass: JSONUtils_createLabelJSON(JSONUtils_createTextSymbolJSON([0, 0, 0, 255], "Arial", 7, 0, 0, "normal", "normal", [0, 0, 0, 180], 0), "$feature.label")
        },
        labelStyle: {
          fontStyle: {
            color: "black",
            fontFamily: "'Arial'",
            fontSize: "9px",
            fontWeight: "600",
            textAlign: "center"
          },
          positionStyle: Ze.labelAnchorCenter
        },
        outlineOpacity: 256
      },
      graphicsWithLabel: {
        polygon: JSONUtils_createSimpleFillSymbolJSON([0, 0, 0, 0], [204, 204, 204], 3),
        point: JSONUtils_createSimpleMarkerSymbolJSON([0, 0, 0, .5], 9, "esriSMSCircle", 0, 0, [204, 204, 204], 1),
        line: Oe([204, 204, 204, .5], 2, "esriSLSSolid"),
        label: {
          field: {
            name: "name",
            type: "esriFieldTypeString"
          }
        },
        labelStyle: {
          fontStyle: _objectSpread(_objectSpread({}, De), {}, {
            fontSize: "12px"
          }),
          positionStyle: Ze.labelAnchorCenter
        }
      },
      loadsheet: {
        default: JSONUtils_createSimpleFillSymbolJSON([0, 0, 0, 0], [0, 0, 0, 200], 2)
      },
      insetMap: {
        default: JSONUtils_createSimpleFillSymbolJSON([255, 200, 0, 255], [200, 150, 0], .5)
      },
      inspex: {
        default: JSONUtils_createSimpleFillSymbolJSON([0, 0, 0, 0], [0, 0, 0, 200], 2),
        fillOpacity: 125,
        outlineOpacity: 256
      },
      yieldBy: {
        default: JSONUtils_createSimpleFillSymbolJSON([0, 0, 0, 0], [200, 200, 200, 200], 2)
      }
    },
    nonFieldFeatures: {
      polygon: JSONUtils_createSimpleFillSymbolJSON([191, 255, 0, 102], [255, 255, 255], 3),
      polyline: Oe([255, 200, 0], 3),
      point: JSONUtils_createSimpleMarkerSymbolJSON([191, 255, 0, 102], 9, "esriSMSCircle", 0, 0, [255, 255, 255], 1),
      polygonLabel: JSONUtils_createTextSymbolJSON([0, 0, 0, 255], "Arial", 10, 0, 0, "normal", "normal", [255, 255, 255, 200], 1.2),
      pointLabel: JSONUtils_createTextSymbolJSON([0, 0, 0, 255], "Arial", 10, 6, 0, "normal", "normal", [255, 255, 255, 200], 1.2, "left"),
      polylineLabel: JSONUtils_createTextSymbolJSON([0, 0, 0, 255], "Arial", 10, 6, 0, "normal", "normal", [255, 255, 255, 200], 1.2, "left"),
      polygonLabelFontStyle: {
        fontFamily: "'Arial'",
        fontWeight: "bold",
        color: "black",
        textShadow: "0 0 0.08em white, 0 0 0.08em white, 0 0 0.08em white",
        textAlign: "center"
      },
      pointLabelFontStyle: {
        fontFamily: "'Arial'",
        fontWeight: "bold",
        color: "black",
        textShadow: "0 0 0.08em white, 0 0 0.08em white, 0 0 0.08em white",
        textAlign: "left",
        paddingLeft: "8px"
      },
      polylineLabelFontStyle: {
        fontFamily: "'Arial'",
        fontWeight: "bold",
        color: "black",
        textShadow: "0 0 0.08em white, 0 0 0.08em white, 0 0 0.08em white",
        textAlign: "left",
        paddingLeft: "8px"
      },
      polygonLabelPositionStyle: Ze.labelAnchorCenter,
      pointLabelPositionStyle: Ze.labelAnchorCenterLeft,
      polylineLabelPositionStyle: Ze.labelAnchorCenterTop
    }
  }
},
    getSize = function getSize(e, t) {
  var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 96;
  return {
    height: e * o,
    width: t * o
  };
},
    Ye = {
  fieldOnly: 0,
  surface: 1
},
    We = (_We = {}, _defineProperty(_We, Ye.fieldOnly, {
  basemap: "reportImagery",
  fieldLabelFields: [ie.fieldName, ie.fieldArea],
  fieldLabels: Je.labels.on,
  fieldLabelStyle: Je.labelStyles.on,
  layers: [Ne.fieldBoundary],
  polygonOpacity: 1,
  sampleSiteLabels: Je.sampleSiteLabels.default,
  sampleSiteLabelStyle: Je.sampleSiteLabelStyles.default,
  size: getSize(5.63, 7.5),
  surfaceOpacity: 1,
  symbols: _defineProperty({}, Ne.fieldBoundary, Je.symbols.fieldBoundary.red),
  useSamplePointIds: !1
}), _defineProperty(_We, Ye.surface, {
  basemap: "reportImagery",
  fieldLabelFields: [ie.fieldName, ie.fieldArea],
  fieldLabels: Je.labels.off,
  fieldLabelStyle: Je.labelStyles.off,
  layers: [Ne.surface, Ne.fieldBoundary],
  polygonOpacity: 1,
  sampleSiteLabels: Je.sampleSiteLabels.default,
  sampleSiteLabelStyle: Je.sampleSiteLabelStyles.default,
  size: getSize(4.88, 6.5),
  surfaceOpacity: 1,
  symbols: _defineProperty({}, Ne.fieldBoundary, Je.symbols.fieldBoundary.white),
  useSamplePointIds: !1
}), _We),
    He = Object.freeze({
  __proto__: null,
  altColor: "rgba(255, 140, 0, 1)",
  labelPageSizeStyles: {
    letter: {
      fontSize: "9px",
      lineHeight: "11px"
    },
    ledger: {
      fontSize: "12px",
      lineHeight: "14px"
    },
    archd: {
      fontSize: "26px",
      lineHeight: "28px"
    },
    arche: {
      fontSize: "32px",
      lineHeight: "36px"
    },
    reallybig: {
      fontSize: "42px",
      lineHeight: "46px"
    }
  },
  options: Je,
  baseType: Ye,
  base: We
}),
    _assign = function _assign(e, t) {
  return Object.assign(JSON.parse(JSON.stringify(We[e])), t);
},
    Xe = {
  reportImages: [_assign(Ye.fieldOnly, {
    _key: ae.REPORT_BOUNDARY_MAP,
    fieldLabelFields: [ie.fieldName, ie.fieldArea],
    fieldLabels: Je.labels.boundaryMap,
    fieldLabelStyle: Je.labelStyles.on,
    layers: [Ne.multiFieldImagery, Ne.fieldBoundary, Ne.nonFieldFeatures],
    showScalebar: !0,
    symbols: (_symbols3 = {}, _defineProperty(_symbols3, Ne.fieldBoundary, Je.symbols.fieldBoundary.red), _defineProperty(_symbols3, Ne.nonFieldFeatures, Je.symbols.nonFieldFeatures), _defineProperty(_symbols3, Ne.polygonGraphics, Je.symbols.polygonFeatures.agvanceSkySoils), _symbols3)
  }), _assign(Ye.surface, {
    _key: ae.AGVANCE_SKY_CROP_PLANNING_REPORT,
    fieldLabels: Je.labels.agvanceSkyDefault,
    fieldLabelStyle: Je.labelStyles.on,
    layers: [Ne.multiFieldImagery, Ne.uniquePolygonGraphics, Ne.fieldBoundary],
    polygonOpacity: 1,
    showScalebar: !0,
    symbols: (_symbols4 = {}, _defineProperty(_symbols4, Ne.fieldBoundary, Je.symbols.fieldBoundary.white), _defineProperty(_symbols4, Ne.uniquePolygonGraphics, Je.symbols.polygonFeatures.cropMap), _symbols4)
  })]
},
    Qe = Object.freeze({
  __proto__: null,
  config: Xe,
  getReportImageConfig: function getReportImageConfig(e) {
    return Xe.reportImages.find(function (t) {
      return t._key.toLowerCase() === (e || "").toLowerCase();
    });
  }
});

var Ve = Object.freeze({
  __proto__: null,
  RecEquationParameter: function RecEquationParameter() {
    _classCallCheck(this, RecEquationParameter);
  }
});
var qe;
!function (e) {
  e[e.Valid = 0] = "Valid", e[e.Invalid = 1] = "Invalid";
}(qe || (qe = {}));

var Ke = new Map(),
    _e = new Map(),
    attemptFuseChunk = function attemptFuseChunk(e) {
  var t;
  var o = se.range(e.count),
      r = null !== (t = Ke.get(e.id)) && void 0 !== t ? t : [],
      i = se.sortBy(r.concat(e), function (e) {
    return e.order;
  }),
      a = se.zip(i, o),
      l = se.every(a, function (e) {
    return null != e[0] && e[0].order === e[1];
  });

  if (i.length === e.count && l) {
    var _e4 = i.map(function (e) {
      return e.data;
    }).join("");

    return {
      model: JSON.parse(_e4)
    };
  }

  return Ke.set(e.id, i), null;
},
    handleSequence = function handleSequence(e, t, o) {
  var r = o.id;

  var i = _e.get(r);

  i || (i = -1);
  var a = o.order;
  return i < a ? (_e.set(r, a), {
    eventName: e,
    model: t
  }) : null;
},
    $e = Object.freeze({
  __proto__: null,

  get InputType() {
    return qe;
  },

  inputFromByteArray: function inputFromByteArray(t) {
    var o = Buffer.from(t).toString();
    var r, i, a;

    try {
      var e = JSON.parse(o);
      r = e.eventName, i = e.sequence, a = e.chunk;
    } catch (e) {
      r = null, i = null, a = null;
    }

    return a && r ? {
      type: qe.Valid,
      eventName: r,
      sequence: i,
      chunk: a
    } : {
      type: qe.Invalid,
      value: o
    };
  },
  createDevice: function createDevice(e, t) {
    var o = ne({
      host: t.host,
      clientId: e,
      protocol: "wss",
      maximumReconnectTimeMs: 8e3,
      debug: !1,
      enableMetrics: !1,
      accessKeyId: t.credentials.accessKeyId,
      secretKey: t.credentials.secretKey,
      sessionToken: t.credentials.sessionToken
    });
    return o.on("error", function (e) {
      return console.error("Underlying MQTT client for IoT has encountered an error.", e);
    }), o;
  },
  toMessage: function toMessage(e) {
    var t = attemptFuseChunk(e.chunk);
    return null == t ? null : e.sequence ? handleSequence(e.eventName, t.model, e.sequence) : {
      eventName: e.eventName,
      model: t.model
    };
  }
}),
    et = Object.freeze({
  __proto__: null
});

export { de as APIHelpers, ce as AuthenticationAPI, ue as ChromelessReportsAPI, pe as ClimateAPI, me as ColorOverrideAPI, Ee as CreditAPI, ye as ImageUtilsAPI, ge as JohnDeereAPI, be as LayerUtilsAPI, Me as MarketPriceAPI, Se as NavigationAPI, Ie as NotificationAPI, he as PicklistAPI, Re as QueueStatusAPI, Ve as RecModels, we as ReportBooksAPI, He as ReportsBaseConfig, Qe as ReportsConfig, ke as ReportsModels, ve as SetupReportBooksAPI, Te as VarietyHybridAPI, $e as messaging, et as pagination };